var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"d3__series"},[_c('Area',{attrs:{"layout":_vm.layout,"series-data":_vm.seriesData,"scale":_vm.scale}}),_c('LineD',{attrs:{"layout":_vm.layout,"series-data":_vm.seriesData,"scale":_vm.scale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }